import styled from 'styled-components';
import { CSSVars } from '../../styles/styles.config';

export const StyledDiv = styled.div`
	color: white;
	display: flex;
	align-items: center;

	.divider {
		margin: 0 10px;
		color: ${CSSVars.gray500};
		font-weight: 500;
	}

	.link {
		text-decoration: none;
		font-size: 14px;
		line-height: 160%;
		padding: 15px 10px;
		border: none;
		padding: 10px 0;
		background: none;
		color: ${CSSVars.gray500};

		&:hover {
			background: none;
			color: ${CSSVars.gray400};
		}
	}

	i {
		margin: -3px 10px 0;
	}
`;
